import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import Reveal from "./Reveal";

const CTA = () => {
  const navigate = useNavigate();
  return (
    <section className="relative py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-br from-primary to-emerald-600 px-8 py-16 text-center shadow-xl sm:px-16">
            <div className="pointer-events-none absolute inset-0 bg-dots opacity-10" />
            <div className="relative">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3.5 py-1.5 text-xs font-medium text-white backdrop-blur">
                <Sparkles className="h-3.5 w-3.5" /> Set up in minutes, no code
              </span>
              <h2 className="mx-auto mt-6 max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
                Hand off your first workflow today
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-lg text-white/85">
                Attach a file, describe the goal, and get a report where every
                figure is checked against your data.
              </p>
              <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                <Button
                  size="lg"
                  className="group rounded-full bg-white px-6 text-base font-semibold text-primary shadow-md transition-transform hover:-translate-y-0.5 hover:bg-white"
                  onClick={() => navigate("/workspace")}
                >
                  Try the live demo
                  <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="rounded-full border-white/40 bg-transparent px-6 text-base font-semibold text-white hover:bg-white/10 hover:text-white"
                  onClick={() => document.querySelector("#pricing")?.scrollIntoView({ behavior: "smooth" })}
                >
                  View pricing
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTA;
